$(document).ready(function() {
  $('[data-open-sidebar]').on('click', function() {
      $('.page-sidebar, .page-content').toggleClass('sidebar-open');
      $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
  });


  const clipboardElements = document.querySelectorAll(".clipboard");
  clipboardElements.forEach(el => {
    el.addEventListener("click", async () => {
      const originalText = el.textContent;

      try {
        await navigator.clipboard.writeText(originalText);

        // Animação de saída
        el.style.opacity = "0";

        setTimeout(() => {
          el.textContent = "COPIADO";
          el.style.opacity = "1";

          // Volta ao original depois de 1.5s
          setTimeout(() => {
            el.style.opacity = "0";
            setTimeout(() => {
              el.textContent = originalText;
              el.style.opacity = "1";
            }, 300);
          }, 1500);
        }, 300);
      } catch (err) {
        console.error("Erro ao copiar texto:", err);
      }
    });
  });


});
